import Constant from '@/const';
import axios from 'axios';

const getTtvRegistration = async id => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat(`/ttv-registration/inpatient/${id}`),
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getTtvRegistration;
